module.exports = __webpack_public_path__ + "img/smart-hero.23da0b49.jpg";